import { jsx as _jsx } from "react/jsx-runtime";
export const mediaSplitMedia = {
    image: _jsx("img", { src: "https://placehold.co/800x800", alt: "", loading: "eager" }),
};
export const mediaSplitMock = {
    title: 'Automate your invoices',
    description: 'Sync Xero and Pleo to keep your books accurate and your team spending within policy.',
    media: mediaSplitMedia,
};
